import React from 'react';
import MoodboardCanvas from './MoodboardCanvas';
import './Garden.css';

interface GardenProps {
  onOpenLoginSignup?: () => void;
  onOpenPhotoBooth?: () => void;
}

const Garden: React.FC<GardenProps> = ({ onOpenLoginSignup, onOpenPhotoBooth }) => {
  return (
    <div className="garden">
      <MoodboardCanvas onOpenLoginSignup={onOpenLoginSignup} onOpenPhotoBooth={onOpenPhotoBooth} />
    </div>
  );
};

export default Garden;